import { Component, OnInit } from '@angular/core';
import { NewAssetWizardService } from 'src/app/services/new-asset-wizard.service';

@Component({
  selector: 'app-new-asset-sidebar',
  templateUrl: './new-asset-sidebar.component.html',
  styleUrls: ['./new-asset-sidebar.component.scss'],
})
export class NewAssetSidebarComponent implements OnInit {

  constructor(
    public assetWizardService: NewAssetWizardService
  ) { }

  ngOnInit() { }

  getAssetList() {
    return this.assetWizardService.assetList;
  }
}
